import React, { useContext, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const ProfileCompletedRoute = ({ children }) => {
    const { user, loading } = useContext(AuthContext);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        // Yükleme bittikten sonra kontrol et
        if (!loading && user) {
            // Google ile giriş yapmış kullanıcılar için profil kontrolü
            // Ve şu an onboarding sayfasında değilse
            if (user.authProvider === 'google' && !user.profileCompleted && location.pathname !== '/onboarding') {
                navigate('/onboarding');
            }
        }
    }, [user, loading, navigate, location.pathname]);

    return <>{children}</>;
};

export default ProfileCompletedRoute;
